import styled from 'styled-components';
import { LabelBold, Skeleton, Small } from '@comeon/ui';

const BetWrapper = styled.div`
	width: 282px;
	min-height: 92px;
	height: 100%;
	border-radius: var(--base-radius-large);
	border: 1px solid var(--generic-stroke-10-percent);
	background-color: var(--main-surface-1);
	background-origin: border-box;
`;

const BetTitleWrapper = styled.div`
	padding: 12px;
`;

const BetTitle = styled(LabelBold)``;

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px;
	gap: 12px;
`;

const BetItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

const BetItemText = styled(Small)``;

const ButtonWrapper = styled.div`
	overflow: hidden;
	border-radius: var(--base-radius-large);
`;
const ButtonSkeleton = styled.div`
	height: 37px;
	width: 100%;
`;

const BetRecommendationsBetSkeleton = () => {
	return (
		<BetWrapper>
			<BetTitleWrapper>
				<Skeleton width="60%">
					<BetTitle>Title</BetTitle>
				</Skeleton>
			</BetTitleWrapper>
			<ContentWrapper>
				<BetItem>
					<Skeleton width="40%">
						<BetItemText>Event</BetItemText>
					</Skeleton>
					<Skeleton width="50%">
						<BetItemText>Selection | Market</BetItemText>
					</Skeleton>
				</BetItem>
				<ButtonWrapper>
					<Skeleton>
						<ButtonSkeleton />
					</Skeleton>
				</ButtonWrapper>
			</ContentWrapper>
		</BetWrapper>
	);
};

export default BetRecommendationsBetSkeleton;
